<template>
<div>
  <v-layout>
    <NewType v-on:created="created($event)" />
    <!-- <router-link :to="{ name:'related-values', params: { schemaId : 121}}" class="dropdown-item">
      <v-btn>
        Grupy relacyjne
      </v-btn>
    </router-link> -->
  </v-layout>
  <v-container fluid grid-list-md>
    <v-app id="inspire">
      <v-data-table :headers="headers" :items="relatedGroupTypes" class="elevation-10">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ getSchemaName(props.item.id) }}</td>
          <td>
            <router-link :to="{ name:'related-values', params: { schemaId : getSchemaId(props.item) }}" class="dropdown-item">
              <v-btn small icon>
                <v-icon small fab block color="green darken-2" style="color: #efefef">search</v-icon>
              </v-btn>
            </router-link>
            <Edit :type.sync="props.item">
              <v-btn slot="activator" small icon>
                <v-icon small fab block color="grey darken-1" style="color: #efefef">edit</v-icon>
              </v-btn>
            </Edit>
            <v-btn @click="deleteSchema(props.item.id)" small icon>
              <v-icon small fab block color="orange darken-3" style="color: #efefef">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-app>
  </v-container>

</div>
</template>
<script>
import NewType from "./NewGroupType"
import Edit from "./EditGroupType"
import NewGroup from './NewGroup'
import http from '@/plugins/http'

export default {
  components: {
    NewType,
    Edit,
    NewGroup
  },
  computed: {
    relatedGroupTypes() {
      return this.$store.state.relatedGroupTypes
    },
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      headers: [{
          text: 'ID',
          value: "id",
          width: "50px"
        },
        {
          text: this.$t('related.name'),
          value: 'name'
        },
        {
          text: this.$t('related.schema'),
          value: 'related_schema_id'
        },
        {
          text: this.$t('related.actions'),
        }
      ]
    }
  },
  methods: {
    created(type) {
      let types = this.relatedGroupTypes
      types.push(type)
      this.$store.commit("setRelatedGroupTypes", types)
    },
    getSchemaId(type) {
      return type["related_schema_id"]
    },
    deleteSchema(id) {
      this.$confirm(this.$t('related.delete_confirmation'))
        .then(res => {
          if (res) {
            http.delete("related/group/type/" + id).then(() => {
              let types = this.relatedGroupTypes
              types = types.filter(el => el.id != id)
              this.$store.commit("setRelatedGroupTypes", types)
            })
          }
        })
    },
    getSchemaName(id) {
      let type = this.relatedGroupTypes.find(el => el.id == id)
      return type ? type["related_schema_name"] : ""
    },
    loadRelatedGroupTypes() {
      if (this.relatedGroupTypes.length == 0)
        return this.$store.dispatch('loadRelatedGroupTypes')
    }
  },
  created() {
    this.loadRelatedGroupTypes()
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}

.filtr-active {
  background-color: green !important;
}
</style>
